import { createRouter, createWebHistory } from 'vue-router'
import baseRouters from './modules/base_router.js'
import {
  isToShowPage
  // storeToken,
} from '@/api/w_api.js'
// import {getGlobleInfo} from '@/utils/request.js'
// import {getUserTokenInScrmReq} from '@/api/hwgk_api.js'
import store from '@/store/index.js'

const routes = [...baseRouters]
const authWhiteList = ['401', '404', 'debug', 'export', 'Search']
// 白名单,此处放不需要token校验的路由地址名
const whiteList = [
  'login',
  ...authWhiteList
]

const router = createRouter({
  history: createWebHistory(import.meta.env.VITE_APP_BASE_URL),
  routes,
  scrollBehavior () {
    return {
      el: '#app',
      top: 0,
      behavior: 'smooth'
    }
  }
})
// 监听刷新
window.addEventListener('beforeunload', () => {
}, {once: true})
window.isZKLogin = window.isZKLogin || 'N'
router.beforeEach(async (to, from, next) => {
  console.log('location.href->' + window.location.href)
  localStorage.removeItem('zkr_campaign_token')
  let openId=store.getters['userStore/getState']('openId')
  console.log('openIdrouter', openId)
  if (whiteList.includes(to.name)) {
    next()
  } else if (openId) {
    next()
  } else
  {
    await isToShowPage(next)
  }
})

router.afterEach((to) => {
  console.log('app.router.after->' + to.name, '::' + to.path + ':login:' + window.isZKLogin)
})

export default router
